import styled from "styled-components";

export const ContentsSection = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
  margin-bottom: 20px;
`;

export const ContentMainLayout = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
`;

export const ContentsTit = styled.div`
  display: flex;
  font-size: 1.6rem;
  font-weight: 650;
  align-items: center;
  gap: 6px;
  span {
    color: ${(props) => props.theme.colors.primary};
  }
  @media (max-width: 410px) {
    font-size: 1.4rem;
  }
`;

export const ContentsState = styled.div`
  display: flex;
  padding: 3px 8px;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 500;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  @media (max-width: 410px) {
    font-size: 1.2rem;
  }
`;

export const BlueText = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-size: 2.4rem;
  font-weight: 750;
  @media (max-width: 410px) {
    font-size: 2.1rem;
  }
`;

export const TextSize = styled.div`
  font-size: 2.4rem;
  font-weight: 550;

  @media (max-width: 410px) {
    font-size: 2.1rem;
  }
`;

export const Alterdiv = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.labelTxt};
  font-size: 1.5rem;
  font-weight: 500;
  background: ${(props) => props.theme.colors.cameraBg};
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  padding: 12px;
  flex-shrink: 0;

  @media (max-width: 410px) {
    font-size: 1.3rem;
    height: 40px;
  }
`;

export const ScrollableBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  border-radius: 8px;
  padding: 25px;
  flex: 1;
  min-height: 0;
  @media (max-width: 410px) {
    padding: 20px;
  }
`;

export const ScrollableArea = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  @media (max-width: 410px) {
    font-size: 1.1rem;
  }
  text-align: justify;
  display: flex;
  flex-direction: column;
  gap: 13px;
  padding: 20px 0;
`;

export const FixedAreaTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 550;
  padding-bottom: 30px;
  padding-top: 20px;
  flex-shrink: 0;
  @media (max-width: 410px) {
    font-size: 1.7rem;
    padding-top: 15px;
  }
`;

export const FixedAreaFoot = styled.div`
  padding: 10px;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 600;
  flex-shrink: 0;
  @media (max-width: 410px) {
    font-size: 1.7rem;
    font-weight: 550;
    height: 40px;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: end;
`;

export const SignButton = styled.button`
  width: 108px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;

  background: none;
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 4px;
  padding: 9px;

  color: ${(props) => props.theme.colors.primary};
  font-size: 1.5rem;
  font-weight: 600;
`;

export const NavigationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const PrevButton = styled.button`
  color: ${(props) => props.theme.colors.primary};
  background: ${(props) => props.theme.colors.white};
  border: ${(props) => props.theme.colors.primary};
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 1.6rem;
  font-weight: 600;
  width: 35%;
  height: 50px;
`;

export const NextButton = styled.button`
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  border: none;
  border-radius: 10px;
  font-size: 1.6rem;
  font-weight: 600;
  width: 65%;
  height: 50px;
`;

export const AgreementPageCheckBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  color: ${(props) => props.theme.colors.inputBorder};
  font-weight: 600;
  font-size: 1.5rem;
  flex-shrink: 0;
  cursor: pointer;

  &.active {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.primary}0F;
    color: ${(props) => props.theme.colors.primary};
  }
`;
